<template>
  <div class="recruitm" >
    <van-sticky>
      <div class="nav">
        <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
        <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
      </div>
      <van-overlay :show="overlayshow" @click="overlayshow = false">
        <div class="wrapper" >
          <div class="nav" v-bind:class="{ 'navActive2': overlayshow }">
            <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
            <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
          </div>
          <div class="navselect" @click="goIndex">
            <van-icon name="arrow" />首页
          </div>
          <div class="navselect" @click="toBg3">
            <van-icon name="arrow" />业务介绍
          </div>
          <div class="navselect"  @click="toBg4">
            <van-icon name="arrow" />合作伙伴
          </div>
          <div class="navselect" @click="toBg5">
            <van-icon name="arrow" />软件著作权
          </div>
          <div class="navselect" @click="toBg6">
            <van-icon name="arrow" />联系我们
          </div>
          <div class="navselect">
            <van-icon name="arrow" />诚聘英才
          </div>
        </div>
      </van-overlay>
    
      
      
    </van-sticky>
    <div class="top"></div>
    <div class="center">
        <van-collapse v-model="activeName" accordion>
            <van-collapse-item title="运营专员(杭州)" name="1">
                <div class="recruitcon">
                    <div class="title">工作地点:</div>
          <div class="txt">浙江银联杭州市环城北路169号</div>
          <div class="title">岗位职责:</div>
          <div class="txt">·负责公司的日常运营工作及公司客户的日常维护 <br>
                            ·从用户角度，追踪整体业务流程中的运营情况，收集用户问题和需求，针对性分析问题，提出优化建议并跟进实现<br>
                            ·负责对平台进行用户数据分析，负责平台周报、月报、季报、年报的撰写等</div>
            <div class="title">任职资格:</div>
            <div class="txt">
                ·大专学历，一年以上工作经验，有互联网金融、第三方支付行业相关工作经验者优先<br>
·熟悉office办公软件，精通Excel、PPT、Word操作<br>
·能独立承担工作任务，对工作有计划、控制能力<br>
·具有一定的分析判断能力、观察力和洞察力；有迅速的的反应能力和问题解决能力 <br>
·工作积极主动、细致、责任心强，有良好的团队协作精神及沟通协调能力，具备良好的总结意识和分析习惯，善于推动工作流程
            </div>
                </div>
            </van-collapse-item>
            <van-collapse-item title="软件工程师" name="2">
                <div class="recruitcon">
                    <div class="title">岗位职责:</div>
          <div class="txt">·业务需求的沟通 <br>
                            ·功能模块详细设计<br>
                            ·业务功能实现与单元测试<br>
                            ·系统维护</div>
            <div class="title">任职资格:</div>
            <div class="txt">
                ·计算机相关专业本科及以上学历<br>
·熟练掌握JSP、Servlet、XML、JDBC、AJAX、HTML、Javascript、CSS等相关技术<br>
·熟悉常用的J2EE开发框架（Struts、Spring、Mybatis等）<br>
·2年以上J2EE项目开发经验 <br>
·工作积极主动，具有良好的文档能力、学习能力、沟通能力及团队合作精神
            </div>
                </div>
            </van-collapse-item>
            </van-collapse>
    </div>
    
      <div class="footer">
        <img src="../assets/mobile/logo@2x.png" >
        <div class="name">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
        <div class="copyright"  @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
      </div>
      <div style="height:200px"></div>
           
    </div>
</template>
<script>
import BScroll from '@better-scroll/core'
export default {
  name: 'recruit_m',
  data (){
    return{
      currentYear: new Date().getFullYear(),
        
      overlayshow:false,
      activeName:'1'
      
    }
  },
  methods:{
   
   gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
    toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },  

  },
  mounted(){
    
  }
}


</script>
<style scoped>
.recruitm {
  width: 100%;

}
.recruitm .center{
    width: 320px;
    margin: 0 auto;
    margin-top: 30px;
}
.recruitm .recruitcon{
    text-align: left;
}
.recruitm .recruitcon .title{
    font-family: PingFangSC-Semibold;
font-size: 12px;
color: #333333;
text-align: justify;
font-weight: 600;
margin-bottom: 4px;
}
.recruitm .recruitcon .txt{
    font-family: PingFangSC-Semibold;
font-size: 12px;
color: #333333;
text-align: justify;
font-weight: 500;
margin-bottom: 20px;
}
.recruitm>>>.van-cell__title{
    font-family: PingFangHK-Semibold;
font-size: 14px;
color: #333333;
font-weight: 600;
text-align: left;
height: 20px;

}
.recruitm>>>.van-collapse-item{
    background: #FFFFFF;
border: 1px solid #DDDDDD;
border-radius: 2px;
border-radius: 2px;
margin-bottom: 10px;
}
.recruitm .top{
    width: 100%;
  background-image: url("../assets/mobile/header_join_us@2x.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 64%;
  margin-top: -40px;
}
.recruitm .nav{
  width: 100%;
  background: rgba(11,21,37,0.80);
  height: 40px;
}
.recruitm .nav .left{
  position: absolute;
  left: 0;
}
.recruitm .nav .left img{
  width: 100px;
  height: 30px;
  margin-left: 10px;
  margin-top: 5px;
}
.recruitm .nav .right{
  float: right;
}
.recruitm .nav .right img{
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 10px;
}
.recruitm .navActive2{
  background-color: #0B1525 ;
}
.recruitm .navselect{
  width: 100%;
  height: 60px;
  background: #0B1525;
  line-height: 60px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: left;
}
.recruitm .navselect .van-icon-arrow{
color: #DBBA66;
margin-left: 14px;
margin-right: 6px;
}

.recruitm>>>.van-swipe__indicator{
width: 20px;
height: 2px;
border-radius: 0;
background: #F1F1F1;
}
.recruitm>>>.van-swipe__indicator--active{
  background: #DBBA66;
}
.recruitm .con3 .title img{
  width: 300px;
  height: 45px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 20px;
}
.recruitm .con3 .box img{
  width: 375px;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 2px;
}


.recruitm .footer{
     width: 100%;
  height: 130px;
  background-image: url("../assets/mobile/footer@2x.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  bottom: 0;
}
.recruitm .footer img{
width: 100px;
height: 30px;
margin:0 auto;
margin-top: 20px;
}
.recruitm .footer .name{
  font-family: PingFangSC-Semibold;
  font-weight: 600;
font-size: 7px;
color: #FFFFFF;
text-align: center;
margin-top: 15px;
}
.recruitm .footer .copyright{
  font-family: PingFangSC-Semibold;
font-size: 7px;
color: #848991;
text-align: center;
margin-top: 3px;
}



</style>